import React from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import FloatingActions from "@/components/layout/FloatingActions";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-tratou-void text-tratou-text">
      <Header />
      <main className="flex-1 pt-16">{children}</main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
